/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SlackMessageBody } from '../models/SlackMessageBody';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class SlackService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public sendErrorMessage(
        requestBody: SlackMessageBody,
    ): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/slack/error',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
